import { Injectable } from "@angular/core";
import { AdminPortalStylingViewModel } from "@modules/api/admin-portal-styling-view-model.generated";
import { GetStylingService } from "@modules/api/get-styling.service.generated";
import { ConcurrentRequestHandlingEnum } from "@modules/common/enums/concurrent-request-handling-enum";
import { CurrentCaseService } from "@modules/common/services/current-case.service";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class CurrentAdminPortalConfigService {
    constructor(
        private _currentCaseService: CurrentCaseService,
        private _getStylingService: GetStylingService
    ) {
        this._currentCaseService.caseChanged.subscribe(x => this.onCasechanged(x));
    }

    private _configChangedSubject = new BehaviorSubject<AdminPortalStylingViewModel | undefined>(undefined);
    private _currentCaseName = '';

    private onCasechanged(currentCaseName: string): void {
        if (this._currentCaseName != currentCaseName && (this._currentCaseName || currentCaseName)) {
            this._currentCaseName = currentCaseName;
            this.refresh();
        }
    }

    public refresh(): void {
        if (this._currentCaseName) {
            this._getStylingService.getStyling({
                concurrentRequestHandling: ConcurrentRequestHandlingEnum.LastOnly,
                useLoadingIndicator: false
            }).subscribe(result =>
                this._configChangedSubject.next(result)
            );
        } else {
            this._configChangedSubject.next(undefined);
        }
    }

    public get configChanged(): Observable<AdminPortalStylingViewModel | undefined> {
        return this._configChangedSubject;
    }
}
